import * as React from 'react';
import { useTranslationHook } from 'PyzShopUi/scripts/utils/translationHook';

const garmentSizeTable = props => {
    const {
        table,
        garmentSizeTypes,
    } = props;
    const { translate } = useTranslationHook();

    const initialState = table.availableCountries.length > 0 ? table.availableCountries[0][1] : '';
    const [selectedCountry, changeCountrySelection] = React.useState(initialState);
    const firstRow = table.sizes[table.firstSizeRowKey];
    // tslint:disable-next-line:no-magic-numbers
    const colspan = (firstRow.hasOwnProperty('order_size') && firstRow.hasOwnProperty('letter_size')) ? 2 : 1;

    const changeCountry = event => {
        changeCountrySelection(event.target.value);
    };

    return <>
        <div className="table-scroll" tabIndex={0}>
            <table>
                <thead>
                <tr>
                        <th className="text-center" colSpan={colspan}> {translate('orderSize', { count: colspan, ns: 'garment-size' })} </th>
                    {firstRow.hasOwnProperty('inch_size') &&
                    <th className="text-center">
                        {translate('Waist size', { ns: 'garment-size'})}
                        <span>{translate('Inch', { ns: 'garment-size'})}</span>
                    </th>
                    }
                    {table.availableCountries.length > 0 &&
                    <th className="text-center">
                        <select onChange={changeCountry} aria-label={translate('customer.address.country', { ns: 'spryker-core'})}>
                            {table.availableCountries
                                .map(country => {
                                    return (<option key={country} value={country[1]}>{translate(country[0], { ns: 'garment-size'})}</option>);
                                })
                            }
                        </select>
                    </th>
                    }

                    {firstRow.hasOwnProperty('A') &&
                    <th className="text-center">A<span>{translate(garmentSizeTypes.A[0], { ns: 'garment-size'})}</span></th>
                    }

                    {firstRow.hasOwnProperty('B') &&
                    <th className="text-center">B<span>{translate(garmentSizeTypes.B[0], { ns: 'garment-size'})}</span></th>
                    }

                    {firstRow.hasOwnProperty('C') &&
                    <th className="text-center">C<span>{translate(garmentSizeTypes.C[0], { ns: 'garment-size'})}</span></th>
                    }

                    {firstRow.hasOwnProperty('D') &&
                    <th className="text-center">D<span>{translate(garmentSizeTypes.D[0], { ns: 'garment-size'})}</span></th>
                    }

                    {firstRow.hasOwnProperty('E') &&
                    <th className="text-center">E<span>{translate(garmentSizeTypes.E[0], { ns: 'garment-size'})}</span></th>
                    }

                    {firstRow.hasOwnProperty('F') &&
                    <th className="text-center">F<span>{translate(garmentSizeTypes.F[0], { ns: 'garment-size'})}</span></th>
                    }

                    {firstRow.hasOwnProperty('G') &&
                    <th className="text-center">G<span>{translate(garmentSizeTypes.G[0], { ns: 'garment-size'})}</span></th>
                    }

                    {firstRow.hasOwnProperty('H') &&
                    <th className="text-center">H<span>{translate(garmentSizeTypes.H[0], { ns: 'garment-size'})}</span></th>
                    }

                    {firstRow.hasOwnProperty('I') &&
                    <th className="text-center">I<span>{translate(garmentSizeTypes.I[0], { ns: 'garment-size'})}</span></th>
                    }
                </tr>
                </thead>
                <tbody>
                {Object
                    .entries(table.sizes)
                    .map(sizesRow => {
                        return <React.Fragment key={sizesRow[0]}>
                            <tr>
                                <td className="text-center">{sizesRow[1].order_size}</td>
                                {firstRow.hasOwnProperty('letter_size') &&
                                <td className="text-center">{sizesRow[1].letter_size}</td>
                                }

                                {firstRow.hasOwnProperty('inch_size') &&
                                <td className="text-center">{sizesRow[1].inch_size}</td>
                                }

                                {table.availableCountries.length > 0 &&
                                <td className="text-center">
                                    {table.availableCountries
                                        .map(country => {
                                            return <React.Fragment key={country[0]}>
                                                <span className={selectedCountry !== country[1] ? 'hide' : ''}
                                                      dangerouslySetInnerHTML={{__html: sizesRow[1][country[1]]}}>
                                                </span>
                                            </React.Fragment>;
                                        })
                                    }
                                </td>
                                }

                                {firstRow.hasOwnProperty('A') &&
                                <td className="text-center">{sizesRow[1].A}</td>
                                }

                                {firstRow.hasOwnProperty('B') &&
                                <td className="text-center">{sizesRow[1].B}</td>
                                }

                                {firstRow.hasOwnProperty('C') &&
                                <td className="text-center">{sizesRow[1].C}</td>
                                }

                                {firstRow.hasOwnProperty('D') &&
                                <td className="text-center">{sizesRow[1].D}</td>
                                }

                                {firstRow.hasOwnProperty('E') &&
                                <td className="text-center">{sizesRow[1].E}</td>
                                }

                                {firstRow.hasOwnProperty('F') &&
                                <td className="text-center">{sizesRow[1].F}</td>
                                }

                                {firstRow.hasOwnProperty('G') &&
                                <td className="text-center">{sizesRow[1].G}</td>
                                }

                                {firstRow.hasOwnProperty('H') &&
                                <td className="text-center">{sizesRow[1].H}</td>
                                }

                                {firstRow.hasOwnProperty('I') &&
                                <td className="text-center">{sizesRow[1].I}</td>
                                }
                            </tr>
                        </React.Fragment>;
                    })
                }
                </tbody>
            </table>
        </div>
    </>;
};

export default garmentSizeTable;
